const esMessages = {
  grid: {
    groupPanelEmpty:
      'Arrastre el título de una columna y suéltelo aquí para agrupar por ese criterio',
    noRecords: 'No hay datos disponibles.',
    pagerFirstPage: 'Ir a la primera página',
    pagerPreviousPage: 'Ir a la página anterior',
    pagerNextPage: 'Ir a la página siguiente',
    pagerLastPage: 'Ir a la última página',
    pagerPage: 'Página',
    pagerOf: 'de',
    pagerTotalPages: '{0}',
    pagerItems: 'ítems',
    pagerInfo: '{0} - {1} de {2} ítems',
    pagerItemsPerPage: 'ítems por página',
    filterEqOperator: 'Es igual a',
    filterNotEqOperator: 'No es igual a',
    filterIsNullOperator: 'Es nulo',
    filterIsNotNullOperator: 'No es nulo',
    filterIsEmptyOperator: 'Está vacío',
    filterIsNotEmptyOperator: 'No está vacío',
    filterStartsWithOperator: 'Comienza con',
    filterContainsOperator: 'Contiene',
    filterNotContainsOperator: 'No contiene',
    filterEndsWithOperator: 'Termina en',
    filterGteOperator: 'Es mayor o igual que',
    filterGtOperator: 'Es mayor que',
    filterLteOperator: 'Es menor o igual que',
    filterLtOperator: 'Es menor o igual que',
    filterIsTrue: 'Sí',
    filterIsFalse: 'No',
    filterBooleanAll: '(Todas)',
    filterAfterOrEqualOperator: 'Es posterior o igual a',
    filterAfterOperator: 'Es posterior',
    filterBeforeOperator: 'Es anterior',
    filterBeforeOrEqualOperator: 'Es anterior o igual a',
    filterSubmitButton: 'Filtrar',
    filterClearButton: 'Limpiar filtros',
    filterAndLogic: 'Y',
    filterOrLogic: 'O',
    filterTitle: 'Filtrar',
    sortAscending: 'Srden ascendente',
    sortDescending: 'Orden descendiente',
    searchPlaceholder: 'Buscar',
    filterCheckAll: 'Comprobar todo',
  },
  filter: {
    eqOperator: 'Es igual a',
    notEqOperator: 'No es igual a',
    isNullOperator: 'Es nula',
    isNotNullOperator: 'No es nula',
    isEmptyOperator: 'Esta vacía',
    isNotEmptyOperator: 'No esta vacía',
    startsWithOperator: 'Comienza con',
    containsOperator: 'Contiene',
    notContainsOperator: 'No contiene',
    endsWithOperator: 'Termina con',
    gteOperator: 'Es mayor o igual a',
    gtOperator: 'Es mayor que',
    lteOperator: 'Es menor o igual que',
    ltOperator: 'Es menos que',
    isTrue: 'Es verdad',
    isFalse: 'Es falsa',
    afterOrEqualOperator: 'Es posterior o igual a',
    afterOperator: 'Es despues',
    beforeOperator: 'Es antes',
    beforeOrEqualOperator: 'Es anterior o igual a',
    andLogic: 'Y',
    orLogic: 'O',
    addExpression: 'Agregar expresión',
    addGroup: 'Añadir grupo',
    close: 'Cerca',
  },
  dateinput: {
    increment: 'Incrementar valor',
    decrement: 'Disminuir valor',
  },
  calendar: {
    today: 'Hoy',
  },
  datepicker: {
    toggleCalendar: 'Alternar calendario',
  },
  daterangepicker: {
    swapStartEnd: 'Intercambiar valores iniciales y finales',
    start: 'Comienzo',
    end: 'Final',
    separator: ' ',
  },
  datetimepicker: {
    date: 'Fecha',
    time: 'Hora',
    toggleDateTimeSelector: 'Alternar selector de fecha y hora',
    cancel: 'Cancelar',
    set: 'Colocar',
  },
  editor: {
    bold: 'Negrita',
    italic: 'Cursiva',
    underline: 'Subrayado',
    strikethrough: 'Tachado',
    subscript: 'Subíndice',
    superscript: 'Superíndice',
    unlink: 'Quitar hiperenlace',
    undo: 'Deshacer',
    redo: 'Rehacer',
    fontSize: 'Tamaño de Fuente',
    fontName: 'Nombre del tipo de letra',
    format: 'Formato',
    alignLeft: 'Alinear texto a la izquierda',
    alignRight: 'Alinear texto a la derecha',
    alignCenter: 'Texto centrado',
    alignJustify: 'Justificar',
    indent: 'Sangría',
    outdent: 'Indentación',
    orderedList: 'Insertar lista ordenada',
    bulletList: 'Insertar lista no ordenada',
    createTable: 'Cree una tabla',
    insertTableHint: 'Cree una tabla de {0} x {1}',
    addRowBefore: 'Suma renglón abajo',
    addRowAfter: 'Agregar fila a continuación',
    addColumnBefore: 'Una columna a la izquierda',
    addColumnAfter: 'Agregar columna a la derecha',
    deleteRow: 'Borrar fila',
    deleteColumn: 'Eliminar columna',
    deleteTable: 'Borrar tabla',
    mergeCells: 'Combinar celdas',
    splitCell: 'Celda dividida',
    hyperlink: 'Insertar hiperenlace',
    'hyperlink-dialog-title': 'Insertar hiperenlace',
    'hyperlink-dialog-content-address': 'Dirección web',
    'hyperlink-dialog-content-title': 'Title',
    'hyperlink-dialog-content-newwindow': 'Abrir enlace en una ventana nueva',
    'hyperlink-dialog-cancel': 'Cancelar',
    'hyperlink-dialog-insert': 'Insertar',
    image: 'Insertar imagen',
    'image-dialog-title': 'Insertar imagen',
    'image-address': 'Dirección web',
    'image-title': 'Title',
    'image-altText': 'Texto alterno',
    'image-width': 'Ancho (px)',
    'image-height': 'Altura (px)',
    'image-cancel': 'Cancelar',
    'image-insert': 'Insertar',
    viewHtml: 'Ver HTML',
    'viewHtml-dialog-title': 'Ver HTML',
    'viewHtml-cancel': 'Cancelar',
    'viewHtml-update': 'Actualizar',
  },
  timepicker: {
    now: 'ahora',
    selectNow: 'select Now',
    cancel: 'cancelar',
    set: 'colocar',
    toggleTimeSelector: 'Alternar TimeSelector',
    toggleClock: 'Alternar reloj',
  },
  dropdowns: {
    nodata: 'DATOS NO ENCONTRADOS.',
    clear: 'Claro',
  },
  numerictextbox: {
    increment: 'Incrementar valor',
    decrement: 'Disminuir valor',
  },
  upload: {
    cancel: 'Cancelar',
    clearSelectedFiles: 'Claro',
    dropFilesHere: 'Arrastra los archivos aquí para subirlos',
    headerStatusUploaded: 'Hecho',
    headerStatusUploading: 'Subiendo ...',
    invalidFileExtension: 'Tipo de archivo no permitido.',
    invalidFiles: 'Archivo(s) inválidos.Compruebe los requisitos de carga de archivos.',
    invalidMaxFileSize: 'Tamaño de archivo demasiado grande.',
    invalidMinFileSize: 'Tamaño del archivo demasiado pequeña.',
    remove: 'Eliminar',
    retry: 'Rever',
    select: 'Selecciona archivos...',
    uploadSelectedFiles: 'Subir',
    total: 'Total',
    files: 'archivos',
  },
  sortable: {
    noData: 'sin datos',
  },
  pager: {
    itemsPerPage: 'ítems por página',
    info: '{0} - {1} de {2} Articulos',
    firstPage: 'Ir a la primera página',
    previousPage: 'Ir a la página anterior',
    nextPage: 'Ir a la siguiente página',
    lastPage: 'Ir a la última página',
    page: 'Página',
    of: 'de',
  },
  treelist: {
    filterClearButton: 'Vaciar',
    filterEqOperator: 'Es igual a',
    filterNotEqOperator: 'No es igual a',
    filterIsNullOperator: 'Es nulo',
    filterIsNotNullOperator: 'No es nulo',
    filterIsEmptyOperator: 'Está vacío',
    filterIsNotEmptyOperator: 'No está vacío',
    filterStartsWithOperator: 'Comienza con',
    filterContainsOperator: 'Contiene',
    filterNotContainsOperator: 'No contiene',
    filterEndsWithOperator: 'Termina por',
    filterGteOperator: 'Es mayor o igual que',
    filterGtOperator: 'Es mayor que',
    filterLteOperator: 'Es menor o igual que',
    filterLtOperator: 'Es menor o igual que',
    filterIsTrue: 'Es verdad',
    filterIsFalse: 'Es falso',
    filterBooleanAll: '(Todas)',
    filterAfterOrEqualOperator: 'Es posterior o igual a',
    filterAfterOperator: 'Es posterior a',
    filterBeforeOperator: 'Es anterior a',
    filterBeforeOrEqualOperator: 'Es anterior o igual a',
    noRecords: 'No hay datos disponibles',
  },
  scheduler: {
    editorValidationRequired: 'El campo es necesario.',
    editorValidationStart: 'La hora de inicio debe ser anterior a la hora de finalización.',
    editorValidationEnd: 'La hora de finalización debe ser posterior a la hora de inicio.',
    allEvents: 'Todos los eventos',
    allDay: 'todo el día',
    today: 'Hoy',
    dayViewTitle: 'Día',
    monthViewTitle: 'Mes',
    weekViewTitle: 'Semana',
    workWeekViewTitle: 'Semana Laboral',
    timelineViewTitle: 'Cronología',
    agendaViewTitle: 'Programa',
    deleteTitle: 'Borrar',
    previousTitle: 'Anterior',
    nextTitle: 'Siguiente',
    showFullDay: 'Todo el Día',
    showWorkDay: 'Mostrar horario laboral',
    editorOccurrence: 'Editar ocurrencia actual',
    editorSeries: 'Editar la Serie',
    editorRecurringConfirmation: '¿Desea eliminar sólo este evento o todas las series?',
    editorRecurringDialogTitle: 'Edita el elemento recurrente',
    editorSave: 'Guardar',
    editorCancel: 'Cancelar',
    editorDelete: 'Borrar',
    editorTitle: 'Evento',
    editorEventTitle: 'Título',
    editorEventStart: 'Comienzo',
    editorEventStartTimeZone: 'Zona horaria de inicio',
    editorEventEnd: 'Final',
    editorEventEndTimeZone: 'Zona horaria de finalización',
    editorEventAllDay: 'Todo el Día',
    editorEventDescription: 'Descripción',
    editorEventSeparateTimeZones: 'Termina en Zona Horaria Diferente',
    editorEventTimeZone: 'Especificar zona horaria',
    recurrenceEditorRepeat: 'Repetir',
    recurrenceEditorDailyInterval: 'día(s)',
    recurrenceEditorDailyRepeatEvery: 'Repetir cada',
    recurrenceEditorWeeklyInterval: 'semana(s)',
    recurrenceEditorWeeklyRepeatEvery: 'Repetir cada',
    recurrenceEditorWeeklyRepeatOn: 'Repetir en',
    recurrenceEditorMonthlyDay: 'Día',
    recurrenceEditorMonthlyInterval: 'mes(es)',
    recurrenceEditorMonthlyRepeatEvery: 'Repetir cada',
    recurrenceEditorMonthlyRepeatOn: 'Repetir en',
    recurrenceEditorYearlyOf: 'de',
    recurrenceEditorYearlyRepeatEvery: 'Repetir cada',
    recurrenceEditorYearlyRepeatOn: 'Repetir en',
    recurrenceEditorYearlyInterval: 'año(s)',
    recurrenceEditorFrequenciesDaily: 'Diaria',
    recurrenceEditorFrequenciesMonthly: 'Mensual',
    recurrenceEditorFrequenciesNever: 'Nunca',
    recurrenceEditorFrequenciesWeekly: 'Semanal',
    recurrenceEditorFrequenciesYearly: 'Anual',
    recurrenceEditorOffsetPositionsFirst: 'Primero',
    recurrenceEditorOffsetPositionsSecond: 'Segundo',
    recurrenceEditorOffsetPositionsThird: 'Tercero',
    recurrenceEditorOffsetPositionsFourth: 'Cuarto',
    recurrenceEditorOffsetPositionsLast: 'Último',
    recurrenceEditorWeekdaysDay: 'Día',
    recurrenceEditorWeekdaysWeekday: 'Día de la semana',
    recurrenceEditorWeekdaysWeekendday: 'Día de Fin de Semana',
    recurrenceEditorEndAfter: 'Después de',
    recurrenceEditorEndOccurrence: 'repetición(es)',
    recurrenceEditorEndLabel: 'Final',
    recurrenceEditorEndNever: 'Nunca',
    recurrenceEditorEndOn: 'Encendido',
    deleteConfirmation: '¿Está seguro de que quiere eliminar este evento?',
    deleteRecurringConfirmation: '¿Desea eliminar sólo este evento o todas las series?',
    deleteOccurrence: 'Eliminar ocurrencia actual',
    deleteSeries: 'Eliminar serie',
    deleteDialogTitle: 'Borrar evento',
    deleteRecurringDialogTitle: 'Borra el elemento recurrente',
    dateTitle: 'Fecha',
    timeTitle: 'Hora',
    eventTitle: 'Evento',
    noEvents: 'Sin eventos',
  },
}
export default esMessages
